import React, { useEffect, useState } from "react";
import TagInputs from "../../layouts/TagInputs";
import notification from "../../../utility/notification";
import { get, post, put } from "../../../utility/fetch";
import { usePatient } from "../../../contexts";
import axios from "axios";
import Spinner from "../../UI/Spinner";

function EmergencyContact({ setSelectedTab, empParam, formLoading, setPayload, submit }) {
  const { patientId } = usePatient();
  const [states, setStates] = useState(null);
  const [payload, setLocalPayload] = useState({
    relationship: "",
    firstName: "",
    lastName: "",
    phone: "",
    email: "",
    contactAddress: "",
    stateOfResidence: "",
    lga: "",
    city: "",
    altPhone: ""
  });

  const { patientInfo, setPatientId, setPatientInfo } = usePatient();

  const gender = [
    { value: "choose", name: "Choose Gender" },
    { value: "Male", name: "Male" },
    { value: "Female", name: "Female" }
  ];

  const maritalStatus = [
    { value: "choose", name: "Choose Marital Status" },
    { value: "Single", name: "Single" },
    { value: "Married", name: "Married" }
  ];

  useEffect(() => {
    if (patientInfo) {
      setLocalPayload(patientInfo?.emergencyContact)
    }
    fetchStates();
  }, [patientInfo]);

  const fetchStates = async () => {
    const token = sessionStorage.getItem('token');
    if (!token) {
      notification({ message: 'Token not found in session storage', type: "error" });
      return;
    }

    const options = {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`
      }
    };

    try {
      let res = await axios.get(`${process.env.REACT_APP_BASE_URL}/clinicapi/api/profile/state/list/1/100`, options);
      let tempDoc = res?.data?.resultList.map((doc) => {
        return { name: doc?.name, value: doc?.name };
      });

      tempDoc?.unshift({ name: "Select State", value: "" });
      setStates(tempDoc);
    } catch (error) {
    }
  };



  const handleChange = (event) => {
    const { name, value } = event.target;

    if ((name === 'phone' || name === 'altPhone') && (isNaN(value) || value.length > 11)) {
      notification({ message: 'Please enter a valid phone number', type: "error" });
      return;
    }

    setLocalPayload(prevPayload => ({ ...prevPayload, [name]: value }));
  };

  const requiredFields = {
    relationship: "Relationship",
    firstName: "First Name",
    lastName: "Last Name",
    phone: "Phone Number",
    email: "Email",
    contactAddress: "Contact Address",
    stateOfResidence: "State Of Residence",
    lga: "LGA",
    city: "City",
    altPhone: "Alternative Phone Number"
  };

  const checkMissingFields = (payload) => {
    const missingFields = Object.keys(requiredFields).filter(field => !payload[field]);
    return missingFields;
  };

  function isValidEmail(email) {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  }

  const submitPayload = async () => {
    console.log(payload)

    const missingFields = checkMissingFields(payload);
    if (missingFields.length > 0) {
      const missingFieldLabels = missingFields.map(field => requiredFields[field]);
      notification({ message: `Missing required fields: ${missingFieldLabels.join(", ")}`, type: "error" });
      return;
    }

    if (!payload.phone || payload.phone.length !== 11 || isNaN(payload.phone)) {
      notification({ message: 'Please make sure phone number is 11 digits', type: "error" });
      return;
    }

    if (!payload.altPhone || payload.altPhone.length !== 11 || isNaN(payload.altPhone)) {
      notification({ message: 'Please make sure alt phone number is 11 digits', type: "error" });
      return;
    }

    if (!isValidEmail(payload.email)) {
      notification({ message: 'Please enter a valid email address', type: "error" });
      return;
    }

    try {
      let res = await put(`/patient/${Number(empParam) - 12345}/emergency-contact-update`, { ...payload});
      if (res.statusCode === 200) {
        notification({ message: res?.data?.message, type: "success" });
        // setSelectedTab("financeHmo");
        sessionStorage.setItem("patientId", res?.patientId);
      } else {
        notification({ message: res?.data?.message, type: "error" });
      }
    } catch (error) {
      notification({ message: error?.detail, type: "error" });
    }
  };



  // const getContact = async () => {
  //   try {
  //     let res = await get(`/patients/${Number(patientId)}/emergencycontact`);
  //     if (res) {
  //       setPayload(res);
  //     }
  //   } catch (error) {
  //     console.error('Error fetching emergency contact details:', error);
  //   }
  // };

  // Add styles for input groups and loader
  const inputGroupStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '16px',
  };

  const inputWrapperStyle = {
    flex: 1,
  };

  const loaderStyle = {
    marginLeft: '8px',
    display: 'flex',
    alignItems: 'center',
  };

  return (
    <div className="w-50">
      <div className="m-t-40"></div>
      
      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.relationship || ''} name="relationship" label="Relationship" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.firstName || ''} name="firstName" label="First Name" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.lastName || ''} name="lastName" label="Last Name" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.phone || payload?.phone || ''} name="phone" label="Phone Number" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.email || ''} name="email" label="Email Address" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.contactAddress || ''} name="contactAddress" label="Contact Address" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} type={'select'} options={states} value={payload?.stateOfResidence || ''} name="stateOfResidence" label="State Of Residence" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.lga || ''} name="lga" label="LGA" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.city || ''} name="city" label="City" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <div style={inputGroupStyle}>
        <div style={inputWrapperStyle}>
          <TagInputs onChange={handleChange} value={payload?.altPhone || ''} name="altPhone" label="Alt Phone Number" />
        </div>
        {formLoading && <div style={loaderStyle}><Spinner width={16} height={16} /></div>}
      </div>

      <button onClick={submitPayload} className="submit-btn m-t-20 w-100">Update</button>
    </div>
  );
}

export default EmergencyContact;
